import * as tslib_1 from "tslib";
import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '../ErrorBoundary';
var Editor = lazy(function () {
    return import(
    /* webpackChunkName: "editor", webpackPrefetch: true */
    './DaEditorWrapper.container');
});
export var LoadableDaEditorWrapper = function (_a) {
    var StaticComponent = _a.staticComponent, LoadingComponent = _a.loadingComponent, forceLoadOnMount = _a.forceLoadOnMount, rest = tslib_1.__rest(_a, ["staticComponent", "loadingComponent", "forceLoadOnMount"]);
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var _c = useState(false), mounted = _c[0], setMounted = _c[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    if (!show && StaticComponent && !forceLoadOnMount) {
        return React.createElement("div", { onClick: function () { return setShow(true); } }, React.createElement(StaticComponent, null));
    }
    if (!StaticComponent && !mounted) {
        return null;
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: React.createElement(LoadingComponent, null) },
            React.createElement(Editor, tslib_1.__assign({}, rest)))));
};
LoadableDaEditorWrapper.displayName = 'LoadableDaEditorWrapper';
export default LoadableDaEditorWrapper;
//# sourceMappingURL=LoadableDaEditorWrapper.js.map